import {PortCallHasPortCallPurposeModel, ShipToShipActivityModel} from './';

export class PortCallPurposeModel {
  portCallPurposeId: number;
  name: string;
  // list models
  portCallHasPortCallPurpose: PortCallHasPortCallPurposeModel[];
  shipToShipActivity: ShipToShipActivityModel[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/port-call-purpose-model.ts